// dispatchers
import { userConfigDispatcher } from '@aceroll/core';

import { StateController, dispatcher, platform, serverData } from "@aceroll/core";
import { featureRound } from '../services';

class FeatureSpinStartController extends StateController {
    slotMachine = null;

    constructor() {
        super("feature.spin.start");
    }

    async onStart() {
        this.slotMachine = dispatcher.app.layout.slotMachine;

        // TODO move to clientData
        const fsName = serverData.featureCount['bonus_1'] > 0 ? 'bonus_1' : 'bonus_2';
        serverData.featureCount[fsName] -= 1;

        featureRound.start();
        // Report that feature round started
        platform.setFeatureRoundStarted({ uistate: "freespins", gameMode: serverData.currentResponse.reelSet });

        // Report that feature counter is being displayed
        platform.setFeatureCounter(serverData.featureCount[fsName]);

        await this.slotMachine.spin();

        userConfigDispatcher.subscribeSlamStop();

        this.stop();
    }

    onStop() {

    }
}

export default FeatureSpinStartController;
